import { RouteRecordRaw } from 'vue-router'

const asyncRoutesForFGYX: RouteRecordRaw[] = [
  {
    path: '',
    name: 'home',
    meta: {
      title: '首页',
      icon: 'HomeFilled',
    },
    redirect: '/tik-tok-home',
    component: () => import('@/layouts/index.vue'),
    children: [
      {
        path: 'tik-tok-home',
        name: 'tik-tok-home',
        meta: {
          title: '抖音首页',
        },
        component: () => import('@/views/Home/TikTokHome/index.vue'),
      },
      {
        path: 'ks-home',
        name: 'ks-home',
        meta: {
          title: '快手首页',
        },
        component: () => import('@/views/Home/KSHome/index.vue'),
      },
    ],
  },
  {
    path: '/financial-management',
    name: 'financial-management',
    meta: {
      title: '财务管理',
      icon: 'Coin',
    },
    redirect: '/financial-management/overview',
    component: () => import('@/layouts/index.vue'),
    children: [
      // {
      //   path: "business-overview",
      //   name: "financial-management-business-overview",
      //   meta: {
      //     title: "经营概览"
      //   },
      //   component: () => import("@/views/FinancialManagement/FinancialSettlement.vue")
      // },

      {
        path: 'overview',
        name: 'overview',
        meta: {
          title: '经营概览',
        },
        redirect: '/financial-management/overview/business-overview',
        children: [
          {
            path: 'business-overview',
            name: 'financial-management-business-overview',
            meta: {
              title: '抖音经营概览',
            },
            component: () => import('@/views/FinancialManagement/FinancialSettlement.vue'),
          },
          {
            path: 'Ks-business-overview',
            name: 'Ks-financial-management-business-overview',
            meta: {
              title: '快手经营概览',
            },
            component: () => import('@/views/KsFinancialManagement/KsFinancialSettlement.vue'),
          },
        ],
      },

      // {
      //     path: 'agency-settlement',
      //     name: 'AgencySettlement',
      //     meta: {
      //         title: '代理结算',
      //     },
      //     component: () => import('@/views/FinancialManagement/AgencySettlement.vue'),
      // },
      // {
      //   path: "employee-settlement",
      //   name: "EmployeeSettlement",
      //   meta: {
      //     title: "员工结算"
      //   },
      //   component: () => import("@/views/FinancialManagement/EmployeeSettlement.vue")
      // },
      {
        path: 'employee-settlementV2',
        name: 'employee-settlementV2',
        meta: {
          title: '员工结算V2',
        },
        redirect: '/financial-management/employee-settlementV2/tik-tok-employee-settlement',
        children: [
          {
            path: 'tik-tok-employee-settlement',
            name: 'tik-tok-employee-settlement',
            meta: {
              title: '抖音员工结算',
            },
            component: () =>
              import('@/views/FinancialManagement/EmployeeSettlementV2/Tiktok/index.vue'),
          },
          {
            path: 'ks-employee-settlement',
            name: 'ks-employee-settlement',
            meta: {
              title: '快手员工结算',
            },
            component: () =>
              import('@/views/FinancialManagement/EmployeeSettlementV2/Kuaishou/index.vue'),
          },
        ],
      },
      // {
      //     path: 'rebate-expenditure',
      //     name: 'CompensationSetting',
      //     meta: {
      //         title: '返点支出',
      //     },
      //     component: () => import('@/views/FinancialManagement/CompensationSetting.vue'),
      // },
    ],
  },
  {
    path: '/data-overview',
    name: 'data-overview',
    meta: {
      title: '数据概览',
      icon: 'Grid',
    },
    redirect: '/data-overview/performance-statistics',
    component: () => import('@/layouts/index.vue'),
    children: [
      {
        path: 'performance-statistics',
        // name: "performance-statistics",
        meta: {
          title: '绩效统计',
        },
        redirect: '/data-overview/performance-statistics',
        // component: () => import("@/views/DataOverview/PerformanceStatistics/index.vue")
        children: [
          {
            path: 'performance-statistics',
            name: 'performance-statistics',
            meta: {
              title: '抖音绩效统计',
            },
            component: () => import('@/views/DataOverview/PerformanceStatistics/index.vue'),
          },
          {
            path: 'KS-performance-statistics',
            name: 'KS-performance-statistics',
            meta: {
              title: '快手绩效统计',
            },
            component: () => import('@/views/DataOverview/KS_PerformanceStatistics/index.vue'),
          },
        ],
      },

      // {
      //   path: "promotion-list",
      //   name: "promotion-list",
      //   meta: {
      //     title: "推广列表"
      //   },
      //   component: () => import("@/views/DataOverview/promotionList/index.vue")
      // },
      {
        path: 'promotion-list-v2',
        name: 'promotion-list-v2',
        meta: {
          title: '推广列表V2',
        },
        redirect: '/performance-statistics/promotion-list-v2/tik-tok-promotion-list-v2',
        children: [
          {
            path: 'tik-tok-promotion-list-v2',
            name: 'tik-tok-promotion-list-v2',
            meta: {
              title: '抖音推广列表',
            },
            component: () => import('@/views/DataOverview/promotionListV2/TikTok/index.vue'),
          },
          {
            path: 'ks-promotion-list-v2',
            name: 'ks-promotion-list-v2',
            meta: {
              title: '快手推广列表',
            },
            component: () => import('@/views/DataOverview/promotionListV2/KuaiShou/index.vue'),
          },
        ],
      },
      // {
      //     path: 'data-distribution',
      //     name: 'data-distribution',
      //     meta: {
      //         title: '数据分配',
      //     },
      //     component: () => import('@/views/DataOverview/DataDistribution/index.vue'),
      // },
      {
        path: 'distribution',
        meta: {
          title: '数据分配',
          // hidden: process.env.NODE_ENV !== 'development',
        },
        redirect: '/data-overview/distribution/tik-tok-order-details',
        children: [
          {
            path: 'Tik-tok-data-distribution',
            name: 'Tik-tok-data-distribution',
            meta: {
              title: '抖音数据分配',
              // hidden: process.env.NODE_ENV !== 'development',
            },
            component: () => import('@/views/DataOverview/TiktokDataDistribution/index.vue'),
          },
          {
            path: 'Ks-data-distribution',
            name: 'Ks-data-distribution',
            meta: {
              title: '快手数据分配',
              // hidden: process.env.NODE_ENV !== 'development',
            },
            component: () => import('@/views/DataOverview/Ks_DataDistribution/index.vue'),
          },
        ],
      },
      // {
      //   path: "Tik-tok-data-distribution",
      //   name: "Tik-tok-data-distribution",
      //   meta: {
      //     title: "抖音数据分配"
      //     // hidden: process.env.NODE_ENV !== "development"
      //   },
      //   component: () => import("@/views/DataOverview/TiktokDataDistribution/index.vue")
      // },
      {
        path: 'distribution/Tik-tok-data-distribution/:id',
        name: 'distribution/Tik-tok-data-distribution-details',
        meta: {
          title: '抖音数据分配 - 详情',
          hidden: true,
        },
        component: () => import('@/views/DataOverview/DataDistributionDetails/index.vue'),
      },
      {
        path: 'distribution/Ks-data-distribution/:id',
        name: 'distribution/Ks-data-distribution',
        meta: {
          title: '快手数据分配 - 详情',
          hidden: true,
        },
        component: () => import('@/views/DataOverview/Ks_DataDistributionDetails/index.vue'),
      },
      {
        path: 'data-distribution/:id',
        name: 'data-distribution-details',
        meta: {
          title: '数据分配 - 详情',
          hidden: true,
        },
        component: () => import('@/views/DataOverview/DataDistributionDetails/index.vue'),
      },
      // {
      //     path: 'order-details',
      //     name: 'data-overview-order-details',
      //     meta: {
      //         title: '订单明细',
      //     },
      //     component: () => import('@/views/DataOverview/OrderDetails/index.vue'),
      // },

      // {
      //   path: "tik-tok-order-details",
      //   name: "tik-tok-order-details",
      //   meta: {
      //     title: "抖音订单明细"
      //     // hidden: process.env.NODE_ENV !== 'development',
      //   },
      //   component: () => import("@/views/DataOverview/tiktokOrderDetails/index.vue")
      // }
      {
        path: 'order-details',

        meta: {
          title: '订单明细',
        },
        redirect: '/data-overview/order-details/tik-tok-order-details',
        children: [
          {
            path: 'tik-tok-order-details',
            name: 'tik-tok-order-details',
            meta: {
              title: '抖音订单明细',
              // hidden: process.env.NODE_ENV !== 'development',
            },
            component: () => import('@/views/DataOverview/tiktokOrderDetails/index.vue'),
          },
          {
            path: 'KS-order-details',
            name: 'KS-order-details',
            meta: {
              title: '快手订单明细',
              // hidden: process.env.NODE_ENV !== 'development',
            },
            component: () => import('@/views/DataOverview/KsOrderDetails/index.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/order-management',
    name: 'order-management',
    meta: {
      title: '订单管理',
      icon: 'Document',
    },
    redirect: '/order-management/channel-order',
    component: () => import('@/layouts/index.vue'),
    children: [
      {
        path: 'channel-order',
        name: 'channel-order',
        meta: {
          title: '渠道订单',
        },
        redirect: '/order-management/channel-order/tik-tok-channel-order',
        children: [
          {
            path: 'tik-tok-channel-order',
            name: 'tik-tok-channel-order',
            meta: {
              title: '抖音渠道订单',
            },
            component: () => import('@/views/OrderManagement/ChannelOrder/TikTok/index.vue'),
          },
          {
            path: 'ks-channel-order',
            name: 'ks-channel-order',
            meta: {
              title: '快手渠道订单',
            },
            component: () => import('@/views/OrderManagement/ChannelOrder/KuaiShou/index.vue'),
          },
        ],
      },
      {
        path: 'Replenishment_order',
        meta: {
          title: '补样订单',
        },
        redirect: '/order-management/Replenishment_order/supplementary-specimen',
        children: [
          {
            path: 'supplementary-specimen',
            name: 'supplementary-specimen',
            meta: {
              title: '抖音补样订单',
            },
            component: () => import('@/views/OrderManagement/SupplementarySpecimen/index.vue'),
          },
          {
            path: 'Ks_supplementary-specimen',
            name: 'Ks_supplementary-specimen',
            meta: {
              title: '快手补样订单',
            },
            component: () => import('@/views/OrderManagement/Ks_SupplementarySpecimen/index.vue'),
          },
        ],
      },
    ],
  },
  // {
  //     path: '/rebate-expenditure',
  //     name: 'RebateExpenditure',
  //     meta: {
  //         title: '薪酬设置',
  //     },
  //     component: () => import('@/views/FinancialManagement/RebateExpenditure.vue'),
  // },
  {
    path: '/master-management',
    name: 'master-management',
    meta: {
      title: '达人管理',
      icon: 'StarFilled',
    },
    redirect: '/master-management/master-list',
    component: () => import('@/layouts/index.vue'),
    children: [
      // {
      //   path: "master-list",
      //   name: "master-list",
      //   meta: {
      //     title: "达人列表"
      //   },
      //   component: () => import("@/views/TalentManagement/MasterList/index.vue")
      // },
      {
        path: 'master-list',
        meta: {
          title: '达人列表',
        },
        redirect: '/master-management/master-list/master-list',
        children: [
          {
            path: 'master-list',
            name: 'master-list',
            meta: {
              title: '抖音达人列表',
            },
            component: () => import('@/views/MasterManagement/MasterList/index.vue'),
          },
          {
            path: 'Ks-master-list',
            name: 'Ks-master-list',
            meta: {
              title: '快手达人列表',
            },
            component: () => import('@/views/KsMasterManagement/MasterList/index.vue'),
          },
        ],
      },
      {
        path: 'open-sea-master-list',
        meta: {
          title: '公海达人列表',
        },
        redirect: '/master-management/open-sea-master-list/open-sea-master-list',
        children: [
          {
            path: 'open-sea-master-list',
            name: 'open-sea-master-list',
            meta: {
              title: '抖音公海达人列表',
            },
            component: () => import('@/views/MasterManagement/OpenSeaMasterList/index.vue'),
          },
          {
            path: 'Ks-open-sea-master-list',
            name: 'Ks-open-sea-master-list',
            meta: {
              title: '快手公海达人列表',
            },
            component: () => import('@/views/MasterManagement/Ks_OpenSeaMasterList/index.vue'),
          },
        ],
      },
      {
        path: 'open-sea-master-review',
        name: 'open-sea-master-review',
        meta: {
          title: '公海达人审核',
        },
        component: () => import('@/views/MasterManagement/OpenSeaMasterReview/index.vue'),
      },
    ],
  },
  {
    path: '/product-management',
    name: 'product-management',
    meta: {
      title: '产品管理',
      icon: 'ShoppingCart',
    },
    redirect: '/product-management/product-list',
    component: () => import('@/layouts/index.vue'),
    children: [
      {
        path: 'product-list',
        name: 'product-list',
        meta: {
          title: '产品列表',
        },
        redirect: '/product-management/product-list/tik-tok-product-list',
        children: [
          {
            path: 'tik-tok-product-list',
            name: 'tik-tok-product-list',
            meta: {
              title: '抖音产品列表',
            },
            component: () =>
              import('@/views/ProductManagement/ProductList/TikTokProductList/index.vue'),
          },
          {
            path: 'ks-product-list',
            name: 'ks-product-list',
            meta: {
              title: '快手产品列表',
            },
            component: () =>
              import('@/views/ProductManagement/ProductList/KSProductList/index.vue'),
          },
        ],
      },
      {
        path: 'product-area',
        name: 'product-area',
        meta: {
          title: '产品专区',
        },
        redirect: '/product-management/product-area/tik-tok-product-area',
        children: [
          {
            path: 'tik-tok-product-area',
            name: 'tik-tok-product-area',
            meta: {
              title: '抖音产品专区',
            },
            component: () =>
              import('@/views/ProductManagement/ProductArea/TikTokProductArea/index.vue'),
          },
          {
            path: 'ks-product-area',
            name: 'ks-product-area',
            meta: {
              title: '快手产品专区',
            },
            component: () =>
              import('@/views/ProductManagement/ProductArea/KSProductArea/index.vue'),
          },
        ],
      },
      {
        path: 'product-area-details',
        name: 'product-area-details',
        meta: {
          title: '专区详情',
          hidden: true,
        },
        redirect: '/product-management/product-area-details/tik-tok-product-area-details',
        children: [
          {
            path: 'tik-tok-product-area-details',
            name: 'tik-tok-product-area-details',
            meta: {
              title: '抖音专区详情',
            },
            component: () =>
              import(
                '@/views/ProductManagement/ProductAreaDetails/TikTokProductAreaDetails/index.vue'
              ),
          },
          {
            path: 'ks-product-area-details',
            name: 'ks-product-area-details',
            meta: {
              title: '快手专区详情',
            },
            component: () =>
              import('@/views/ProductManagement/ProductAreaDetails/KSProductAreaDetails/index.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/company-management',
    name: 'company-management',
    meta: {
      title: '组织管理',
      icon: 'Switch',
    },
    redirect: '/company-management/company-management',
    component: () => import('@/layouts/index.vue'),
    children: [
      {
        path: 'company-management',
        name: 'CompanyManagement',
        meta: {
          title: '公司管理',
        },
        component: () => import('@/views/OrganizationManagement/CompanyManagement/index.vue'),
      },
      {
        path: 'department-management',
        name: 'DepartmentManagement',
        meta: {
          title: '部门管理',
        },
        component: () => import('@/views/OrganizationManagement/DepartmentManagement/index.vue'),
      },
      {
        path: 'employee-management',
        name: 'EmployeeManagement',
        meta: {
          title: '员工管理',
        },
        component: () => import('@/views/OrganizationManagement/EmployeeManagement/index.vue'),
      },
    ],
  },
  {
    path: '/configuration-management',
    name: 'configuration-management',
    meta: {
      title: '配置管理',
      icon: 'Setting',
    },
    redirect: '/configuration-management/pc-carousel',
    component: () => import('@/layouts/index.vue'),
    children: [
      {
        path: 'pc-carousel',
        name: 'pc-carousel',
        meta: {
          title: 'PC轮播图',
        },
        component: () => import('@/views/ConfigurationManagement/PcCarousel/index.vue'),
      },
      {
        path: 'express-logistics',
        name: 'express-logistics',
        meta: {
          title: '快递物流记录',
        },
        component: () => import('@/views/ConfigurationManagement/ExpressLogistics/index.vue'),
      },
      {
        path: 'ai-usage-records',
        name: 'ai-usage-records',
        meta: {
          title: 'AI使用记录',
        },
        component: () => import('@/views/ConfigurationManagement/AiUsageRecords/index.vue'),
      },
      {
        path: 'ArticleList',
        name: 'ArticleList',
        meta: {
          title: '文章列表',
        },
        component: () => import('@/views/ConfigurationManagement/ArticleList/index.vue'),
      },
      {
        path: 'ArticleSubmission',
        name: 'ArticleSubmission',
        meta: {
          title: '文章发布',
        },
        component: () => import('@/views/ConfigurationManagement/ArticleSubmission/index.vue'),
      },
      {
        path: 'authorization-management',
        name: 'authorization-management',
        meta: {
          title: '授权管理',
        },
        redirect:
          '/configuration-management/authorization-management/tik-tok-authorization-management',
        children: [
          {
            path: 'tik-tok-authorization-management',
            name: 'tik-tok-authorization-management',
            meta: {
              title: '抖音授权管理',
              // hidden: true
            },
            component: () =>
              import(
                '@/views/ConfigurationManagement/AuthorizationManagement/TikTokAuthorizationManagement/index.vue'
              ),
          },
          {
            path: 'ks-authorization-management',
            name: 'ks-authorization-management',
            meta: {
              title: '快手授权管理',
              // hidden: true
            },
            component: () =>
              import(
                '@/views/ConfigurationManagement/AuthorizationManagement/KSAuthorizationManagement/index.vue'
              ),
          },
        ],
      },
    ],
  },
  {
    path: '/admin-super-panel',
    name: 'admin-super-panel',
    meta: {
      title: '超级面板',
      icon: 'Postcard',
    },
    redirect: '/admin-super-panel',
    component: () => import('@/layouts/index.vue'),
    children: [
      {
        path: 'tiktok-data-relationships-list',
        name: 'tiktok-data-relationships-list',
        meta: {
          title: '抖音数据关系列表',
        },
        component: () => import('@/views/AdminSuperPanel/TiktokDataRelationshipsList/index.vue'),
      },
      {
        path: 'tiktok-platform-order-list',
        name: 'tiktok-platform-order-list',
        meta: {
          title: '抖音平台订单列表',
        },
        component: () => import('@/views/AdminSuperPanel/TiktokPlatformOrderList/index.vue'),
      },
      {
        path: 'tiktok-data-Statistical-distribution',
        name: 'tiktok-data-Statistical-distribution',
        meta: {
          title: '抖音数据统计分配',
        },
        component: () =>
          import('@/views/AdminSuperPanel/TiktokDataStatisticalDistribution/index.vue'),
      },
      {
        path: 'tiktok-employee-group-center-for-fgyx',
        name: 'tiktok-employee-group-center-for-fgyx',
        component: () =>
          import(
            '@/views/CompanyManagement/EmployeeGroupCenter/TikTokEmployeeGroupCenter/index.vue'
          ),
        meta: {
          title: '抖音员工榜单分组',
        },
      },
    ],
  },
]

export default asyncRoutesForFGYX
